import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task03 } from "../../../../../task/course-05/lesson-12/task-03";

const task: Slide = {
  titleHtml:
    "There is a ventilation source in the room with predefined sound power. If we add the<br>absoprtion material on one defined surface in the room with dimension L = 6 m,<br>W = 4,8 m and H = 2,7 m the sound pressure level in the room will be:",
  description: "Select the correct answer.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/12/task/task-3.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task03.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
